import { Injectable } from '@angular/core';
import { ConfiguracionConsumosFilters } from '../models/configuracion-consumos-filters.component';
import { DisenyoEtiquetasFilters } from '../models/disenyo-etiquetas-filters.component';
import { MantenimientoEtiquetasFilters } from '../models/mantenimiento-etiquetas-filters.component';
import { MantenimientoRoyaltiesFilters } from '../models/mantenimiento-royalties-filters.component';

@Injectable()
export class ConfiguracionContextService {
    public disenyoEtiquetasFilters: DisenyoEtiquetasFilters;
    public mantenimientoEtiquetasFilters: MantenimientoEtiquetasFilters;
    public configuracionConsumosFilters: ConfiguracionConsumosFilters;
    public mantenimientoRoyaltiesFilters: MantenimientoRoyaltiesFilters;
}
